import Contentful from 'contentful'
import CFRichTextTypes from '@contentful/rich-text-types'

export enum TableHorizontalAlignment {
  Left = 'Left',
  Center = 'Center',
  Right = 'Right',
}

export enum TableVerticalAlignment {
  Top = 'Top',
  Center = 'Center',
  Bottom = 'Bottom',
}

export enum TableHeaderFont {
  HeadingXLarge = 'HeadingXLarge',
  HeadingLarge = 'HeadingLarge',
  HeadingMedium = 'HeadingMedium',
  SubheadingLarge = 'SubheadingLarge',
  SubheadingMedium = 'SubheadingMedium',
  SubheadingSmall = 'SubheadingSmall',
}

export enum TableBodyFont {
  NormalTextLarge = 'NormalTextLarge',
  NormalTextMedium = 'NormalTextMedium',
  NormalTextSmall = 'NormalTextSmall',
}

export interface TypeComponentTableFields {
  internalName: Contentful.EntryFields.Symbol
  content: CFRichTextTypes.Document
  primaryHeader: boolean
  firstRowAsHeader: boolean
  firstColumnAsHeader: boolean
  headerHorizontalAlignment: TableHorizontalAlignment
  headerVerticalAlignment: TableVerticalAlignment
  headerFontSize: TableHeaderFont
  fontSize: TableBodyFont
  horizontalAlignment: TableHorizontalAlignment
  verticalAlignment: TableVerticalAlignment
  zebraStriping: boolean
}

export type TypeComponentTable = Contentful.Entry<TypeComponentTableFields>
